var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diff-panel"},_vm._l((_vm.lines),function(l){return _c('div',{key:l.num,class:{added: l.added, removed: l.removed}},[_vm._v(_vm._s(l.value))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }